var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-tooltip',{attrs:{"placement":"bottom"}},[_c('template',{slot:"title"},[_vm._v(" 刷新页面 ")]),_c('img',{staticStyle:{"height":"28px","cursor":"pointer"},attrs:{"src":require("@/assets/topBtn/2.png")},on:{"click":_vm.refreshPage}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }